// kiểu bar chart hiển thị dữ liệu
export default {
  Column: 1, // dạng cột
  Donut: 0, // dạng tròn
};
